import { render, staticRenderFns } from "./GigDetailsCard.htm?vue&type=template&id=8db4018e&scoped=true&"
import script from "./GigDetailsCard.ts?vue&type=script&lang=js&"
export * from "./GigDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./GigDetailsCard.scss?vue&type=style&index=0&id=8db4018e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4018e",
  null
  
)

export default component.exports